<template>
	<div class="ingredient">
		<p
			class="ingredient__noti"
			v-text="
				'※ 성분명으로 검색된 성분 항목을 클릭하여 추가할 수 있습니다.'
			"
		/>
		<p
			class="ingredient__noti"
			v-text="`※ 성분 추가 후 '등록'을 클릭해야 등록이 완료됩니다.`"
		/>
		<div class="ingredient__content-wrapper">
			<div class="ingredient__content">
				<div class="ingredient__search">
					<p class="ingredient__content-title" v-text="'성분 검색'" />
					<button class="btn border" @click="newIngredient">
						신규 성분 등록
					</button>
				</div>
				<FactorSearcher
					:selectedList="selectedList"
					@addFactor="addFactor"
				/>
			</div>
			<div class="ingredient__content">
				<div class="ingredient__search">
					<p class="ingredient__content-title" v-text="'성분 추가'" />
					<button class="btn border" @click="callIngredient">
						성분 불러오기
					</button>
				</div>
				<IngredientDragDrop
					append-to=".modal"
					helper-class="ingredient__dragger"
					:list="selectedList"
					@change="changeSelectedList"
				/>
			</div>
		</div>
		<div class="btn-wrap-main ingredient__button-box">
			<button
				class="btn-main"
				v-text="'초기화'"
				@click="selectedListInit"
			/>
			<button class="btn-main blue" v-text="'등록'" @click="register" />
		</div>
		<div class="btn-wrap-main">
			<button class="btn-main" v-text="'닫기'" @click="closeModal" />
		</div>
		<div
			class="ingredient__serach-wrap"
			@click="closeOnOutsideClick"
			v-if="isIngredinentModal"
		>
			<div class="ingredient__search-modal" @click.stop>
				<button
					class="btn ingredient__btn-close"
					type="button"
					@click="closeSearchModal"
				>
					<i
						class="ingredient__btn-close__icon fa fa-times"
						aria-hidden="true"
					></i>
				</button>
				<div class="ingredient__search-item">
					<ProductSearcher2
						ref="product_selector"
						@change="onSelectProduct"
						mode="search_view"
					/>
					<p class="ingredient__item-name">
						선택 제품 :
						<span
							v-html="selectedProduct"
							class="ingredient__select-name"
						></span>
					</p>
					<div class="ingredient__button-list">
						<button
							class="btn blue ingredient__search-button"
							@click="searchIngredient"
						>
							성분 불러오기
						</button>
						<button
							class="btn border ingredient__search-button"
							@click="selectInit"
						>
							취소
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { mapState } from 'vuex';
	import IngredientDragDrop from '@/components/product/IngredientDragDrop.vue';
	import FactorSearcher from '@/components/product/FactorSearcher.vue';
	import ProductSearcher2 from '@/components/ProductSearcher2';

	export default {
		name: 'ProductIngredientController',
		components: {
			IngredientDragDrop,
			FactorSearcher,
			ProductSearcher2,
		},
		data() {
			return {
				selectedList: [],
				selectedProduct: '',
				selectedProductId: null,
				isIngredinentModal: false,
			};
		},
		computed: {
			...mapState({
				params: state => state.modal.params,
			}),
		},
		methods: {
			selectedListInit() {
				if (
					!confirm('입력한 항목이 모두 삭제됩니다. 삭제하시겠습니까?')
				)
					return;
				this.selectedList = [];
			},
			changeSelectedList(newList) {
				this.selectedList = newList;
			},
			closeModal() {
				this.$store.commit('modal/toggleModal', false);
			},
			register() {
				const factorList = this.selectedList.map((item, idx) => ({
					factorIdx: item.id,
					orderIndex: idx,
					factorName: item.value,
				}));
				if (this.params.register) {
					this.params.register(factorList);
				}
				this.closeModal();
			},
			init() {
				this.selectedList = this.params.selectedList;
			},
			addFactor(list) {
				this.selectedList = [...this.selectedList, ...list];
			},
			newIngredient() {
				window.open(
					'/product/ingredient-list',
					'_blank',
					'noopener,noreferrer'
				);
			},
			callIngredient() {
				this.isIngredinentModal = true;
			},
			closeSearchModal() {
				this.isIngredinentModal = false;
			},
			onSelectProduct(product) {
				this.selectedProduct = product.name;
				this.selectedProductId = product.idProduct;
			},
			selectInit() {
				this.$refs.product_selector.init();
				this.selectedProduct = '';
			},
			closeOnOutsideClick() {
				if (this.isIngredinentModal === true) {
					this.isIngredinentModal = false;
				} else {
					this.isIngredinentModal = true;
				}
			},
			async searchIngredient() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/api/products/searchProductFactor?idProduct=${this.selectedProductId}`
					);

					data.forEach(item => {
						const exists = this.selectedList.some(
							listItem => listItem.id === item.factorIdx
						);
						if (!exists) {
							this.selectedList.push({
								id: item.factorIdx,
								value: `${item.factorKorean}(${item.factorEnglish})`,
							});
						}
					});
					this.isIngredinentModal = false;
					this.selectInit();
				} catch (err) {
					console.error(err);
					if (err.response.status === 404) {
						alert('해당제품에 맵핑된 성분이 없습니다.');
					} else {
						alert(
							'제품 성분을 불러오는데 실패하였습니다. 개발팀에 문의하세요'
						);
					}
				}
			},
		},
		mounted() {
			this.init();
		},
	};
</script>
<style lang="scss" scoped>
	.ingredient {
		position: relative;
		&__noti {
			margin: 12px 0 0;
			color: $btn-blue;
			font-size: 1rem;
			font-weight: 700;
		}

		&__content-wrapper {
			display: flex;
		}

		&__search {
			display: flex;
			justify-content: space-between;
		}

		&__content {
			width: 50%;
			padding: 14px;
		}

		&__content-title {
			margin-bottom: 14px;
			line-height: 36px;
			font-size: 1rem;
			font-weight: 700;
		}

		&__dragger {
			overflow: hidden;
			display: block;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		&__button-box {
			padding-bottom: 0;
			text-align: right;
		}
		&__serach-wrap {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			left: 0;
			background: rgba(84, 84, 84, 0.6);
		}

		&__search-modal {
			width: 800px;
			height: 250px;
			border: 1px solid #000;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			background: #fff;
		}

		&__search-item {
			padding: 40px;
			display: flex;
			justify-content: center;
			flex-direction: column;
			align-items: center;
		}

		&__item-name {
			margin-top: 20px;
			font-size: 13px;
		}

		&__select-name {
			font-size: 18px;
		}

		&__button-list {
			display: flex;
			justify-content: center;
			align-items: center;
			gap: 20px;
		}
		&__search-button {
			width: 150px;
			height: 40px;
			margin-top: 20px;
		}

		&__btn-close {
			position: absolute;
			top: 10px;
			right: 10px;
			width: 27px;
			height: 27px;
			padding: 0;
			border: none;
			border-radius: 0;

			&:before {
				margin: 0;
			}

			&:after {
				display: none;
			}
		}
		&__btn-close__icon {
			cursor: pointer;
			font-size: 1.5rem;
		}
	}
</style>
